module.exports = __webpack_public_path__ + "img/b609875.jpg";